import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "form-list-wrapper" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "card-head border-0 mb-0" }, [
  /*#__PURE__*/_createVNode("h1", { class: "card-title" }, "Search forms")
], -1)
const _hoisted_4 = { class: "form-wrap mt-lg-3" }
const _hoisted_5 = { class: "input-btn" }
const _hoisted_6 = {
  class: "tag-wrapper",
  id: "popularTagsForTemplateSearch"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Popular tags : ")
const _hoisted_9 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Display form")
], -1)
const _hoisted_10 = {
  class: "row mb-0 mt-3",
  id: "displayFormTemplate"
}
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", {
  for: "all",
  class: "ml-1"
}, "All", -1)
const _hoisted_13 = { class: "col-md-4 col-6" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", {
  for: "sent_by_me",
  class: "ml-1"
}, "Sent by me", -1)
const _hoisted_15 = { class: "col-md-4 col-6" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", {
  for: "sent_to_me",
  class: "ml-1"
}, "Sent to me", -1)
const _hoisted_17 = { class: "recently-used-forms" }
const _hoisted_18 = {
  class: "table-responsive my-3",
  id: "displayFormTemplateSearch"
}
const _hoisted_19 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_20 = /*#__PURE__*/_createVNode("thead", { class: "table-primary text-nowrap" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Form Name"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Send To Users"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Created Date"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Updated Date"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Action")
  ])
], -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { href: "javascript:void(0)" }
const _hoisted_23 = { class: "block-list email-list" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "table-button" }
const _hoisted_27 = /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Edit")
const _hoisted_29 = /*#__PURE__*/_createVNode("i", { class: "fa fa-paper-plane" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Send")
const _hoisted_31 = /*#__PURE__*/_createVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" View Details")
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("td", { colspan: "5" }, [
    /*#__PURE__*/_createVNode("p", { class: "text-danger text-center" }, [
      /*#__PURE__*/_createVNode("strong", null, "No Templates !!! Create New")
    ])
  ])
], -1)
const _hoisted_35 = { class: "my-3" }
const _hoisted_36 = { "aria-label": "Page navigation example" }
const _hoisted_37 = { class: "modal-wrap default-modal" }
const _hoisted_38 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "sendoption",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_39 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_40 = { class: "modal-content" }
const _hoisted_41 = { class: "modal-header" }
const _hoisted_42 = /*#__PURE__*/_createVNode("svg", {
  class: "svg-inline--fa fa-chevron-left fa-w-10",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "chevron-left",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512",
  "data-fa-i2svg": ""
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
  })
], -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, "send option")
], -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_45 = { class: "modal-body" }
const _hoisted_46 = { class: "form-wrap pt-0" }
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Select project", -1)
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Select channel", -1)
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Choose member", -1)
const _hoisted_53 = { class: "mb-0" }
const _hoisted_54 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = /*#__PURE__*/_createVNode("label", { for: "" }, "Additional message", -1)
const _hoisted_57 = { class: "modal-footer d-block" }
const _hoisted_58 = { class: "row align-items-end no-gutters" }
const _hoisted_59 = { class: "col-lg-6" }
const _hoisted_60 = { class: "share-form-block form-inline" }
const _hoisted_61 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "mb-1 mr-2"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-lock mb-1 mr-2" }),
  /*#__PURE__*/_createTextVNode(" Share this Form : ")
], -1)
const _hoisted_62 = {
  key: 0,
  class: "form-wrap pt-0"
}
const _hoisted_63 = { class: "tooltip-block" }
const _hoisted_64 = /*#__PURE__*/_createVNode("i", { class: "far fa-question-circle ml-2" }, null, -1)
const _hoisted_65 = { class: "tooltip-msg" }
const _hoisted_66 = { class: "mb-0" }
const _hoisted_67 = { class: "col-lg-6" }
const _hoisted_68 = { class: "col-button" }
const _hoisted_69 = { class: "send-to modal-wrap xl-size" }
const _hoisted_70 = {
  class: "modal fade",
  id: "formPreviewModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_71 = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
  role: "document"
}
const _hoisted_72 = { class: "modal-content" }
const _hoisted_73 = { class: "modal-header" }
const _hoisted_74 = { class: "d-block" }
const _hoisted_75 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_76 = { class: "text-muted" }
const _hoisted_77 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_78 = { class: "modal-body" }
const _hoisted_79 = { class: "form-wrap pt-0" }
const _hoisted_80 = { disabled: "" }
const _hoisted_81 = {
  key: 6,
  class: "form-block text-field"
}
const _hoisted_82 = {
  key: 0,
  class: "readonly-title"
}
const _hoisted_83 = {
  key: 7,
  class: "form-block text-field"
}
const _hoisted_84 = { class: "row" }
const _hoisted_85 = { class: "col-md-2" }
const _hoisted_86 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-signature fa-3x" })
], -1)
const _hoisted_87 = {
  key: 0,
  class: "readonly-title"
}
const _hoisted_88 = { class: "modal-footer justify-content-between" }
const _hoisted_89 = {
  key: 0,
  class: "form-sender"
}
const _hoisted_90 = { class: "mb-0" }
const _hoisted_91 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user mr-1" }, null, -1)
const _hoisted_92 = /*#__PURE__*/_createTextVNode(" Sent by : ")
const _hoisted_93 = { key: 0 }
const _hoisted_94 = /*#__PURE__*/_createTextVNode(" on ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_pagination = _resolveComponent("v-pagination")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_TitleComponent = _resolveComponent("TitleComponent")
  const _component_TextBoxComponent = _resolveComponent("TextBoxComponent")
  const _component_RadioButtonComponent = _resolveComponent("RadioButtonComponent")
  const _component_SelectOption = _resolveComponent("SelectOption")
  const _component_CheckBox = _resolveComponent("CheckBox")
  const _component_TextArea = _resolveComponent("TextArea")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _withDirectives(_createVNode("input", {
            id: "searchTemplateByText",
            type: "text",
            class: "form-control",
            placeholder: "Search form eg.Kitchen forms, etc",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.data.filter.formName = $event)),
            onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
          }, null, 544), [
            [_vModelText, _ctx.state.data.filter.formName]
          ]),
          _createVNode("a", {
            href: "javascript:void(0)",
            class: "btn default-btn",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
          }, "search")
        ]),
        _createVNode("div", _hoisted_6, [
          (_ctx.state.data.tagList.length>0)
            ? (_openBlock(), _createBlock("p", _hoisted_7, [
                _hoisted_8,
                _createVNode("a", {
                  href: "javscript:void()",
                  class: _ctx.state.data.filter.tag  === 'all' ? 'tags selected-tag' :'tags',
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.serarchTag('all')))
                }, "All", 2),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.tagList, (tag, tagIndex) => {
                  return (_openBlock(), _createBlock("span", { key: tagIndex }, [
                    _createVNode("a", {
                      class: _ctx.state.data.filter.tag  === tag.tags ? 'tags selected-tag' :'tags',
                      href: "javscript:void()",
                      onClick: ($event: any) => (_ctx.serarchTag(tag.tags))
                    }, _toDisplayString(tag.tags) + " (" + _toDisplayString(tag.myCount) + ") ", 11, ["onClick"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_9,
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _withDirectives(_createVNode("input", {
              type: "radio",
              id: "all",
              name: "gender",
              value: "all",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.filter.type = $event)),
              onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
            }, null, 544), [
              [_vModelRadio, _ctx.state.data.filter.type]
            ]),
            _hoisted_12
          ]),
          _createVNode("div", _hoisted_13, [
            _withDirectives(_createVNode("input", {
              type: "radio",
              id: "sent_by_me",
              name: "gender",
              value: "sent_by_me",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.filter.type = $event)),
              onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
            }, null, 544), [
              [_vModelRadio, _ctx.state.data.filter.type]
            ]),
            _hoisted_14
          ]),
          _createVNode("div", _hoisted_15, [
            _withDirectives(_createVNode("input", {
              type: "radio",
              id: "sent_to_me",
              name: "gender",
              value: "sent_to_me",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.filter.type = $event)),
              onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
            }, null, 544), [
              [_vModelRadio, _ctx.state.data.filter.type]
            ]),
            _hoisted_16
          ])
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode("div", _hoisted_18, [
          _createVNode("table", _hoisted_19, [
            _hoisted_20,
            (_ctx.templateList)
              ? (_openBlock(), _createBlock("tbody", _hoisted_21, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.templateList, (form, formIndex) => {
                    return (_openBlock(), _createBlock("tr", { key: formIndex }, [
                      _createVNode("td", {
                        onClick: ($event: any) => (_ctx.showFormView(form))
                      }, [
                        _createVNode("div", null, [
                          _createVNode("h5", null, [
                            _createVNode("a", _hoisted_22, _toDisplayString(form.title), 1)
                          ])
                        ]),
                        _createVNode("div", null, [
                          _createVNode("p", null, _toDisplayString(form.description), 1)
                        ])
                      ], 8, ["onClick"]),
                      _createVNode("td", null, [
                        _createVNode("div", _hoisted_23, [
                          (form.sentToUsers && form.sentToUsers.length)
                            ? (_openBlock(), _createBlock("ul", _hoisted_24, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.sentToUsers, (user, userIndex) => {
                                  return (_openBlock(), _createBlock("li", {
                                    class: "active",
                                    key: userIndex
                                  }, [
                                    _createTextVNode(_toDisplayString(user.email), 1),
                                    (userIndex < form.sentToUsers.length - 1)
                                      ? (_openBlock(), _createBlock("span", _hoisted_25, ", "))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("td", null, [
                        _createVNode("p", null, _toDisplayString(_ctx.formatDate(form.created_date)), 1)
                      ]),
                      _createVNode("td", null, [
                        _createVNode("p", null, _toDisplayString(_ctx.formatDate(form.updated_date)), 1)
                      ]),
                      _createVNode("td", null, [
                        _createVNode("div", _hoisted_26, [
                          (form.elements && form.elements.length)
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                title: "Edit",
                                "data-toggle": "tooltip",
                                "data-placement": "top",
                                onClick: ($event: any) => (_ctx.editSelectedForm(form)),
                                href: "javascript:void(0)",
                                class: "btn edit-btn mr-1"
                              }, [
                                _hoisted_27,
                                _hoisted_28
                              ], 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          _createVNode("a", {
                            title: "Send to",
                            onClick: ($event: any) => (_ctx.sendSelectedForm(form)),
                            href: "javascript:void(0)",
                            class: "btn send-btn mr-1"
                          }, [
                            _hoisted_29,
                            _hoisted_30
                          ], 8, ["onClick"]),
                          _createVNode("a", {
                            title: "View",
                            href: "javascript:void(0)",
                            class: "btn view-btn mr-0",
                            onClick: ($event: any) => (_ctx.selectForm(form))
                          }, [
                            _hoisted_31,
                            _hoisted_32
                          ], 8, ["onClick"])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("tfoot", _hoisted_33, [
                  _hoisted_34
                ]))
          ]),
          _createVNode("div", _hoisted_35, [
            _createVNode("nav", _hoisted_36, [
              _createVNode(_component_v_pagination, {
                modelValue: _ctx.state.data.paging.getAccountFormList.currentPage,
                "onUpdate:modelValue": [
                  _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.data.paging.getAccountFormList.currentPage = $event)),
                  _ctx.nextPage
                ],
                pages: _ctx.state.data.paging.getAccountFormList.totalPages,
                "range-size": 1,
                "active-color": "#DCEDFF"
              }, null, 8, ["modelValue", "pages", "onUpdate:modelValue"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_37, [
      _createVNode("div", _hoisted_38, [
        _createVNode("div", _hoisted_39, [
          _createVNode("div", _hoisted_40, [
            _createVNode("div", _hoisted_41, [
              _createVNode("div", {
                class: "modal-back-btn",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.sendOptionBack && _ctx.sendOptionBack(...args)))
              }, [
                _hoisted_42
              ]),
              _hoisted_43,
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.hideSendOptionModal && _ctx.hideSendOptionModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_44
              ])
            ]),
            _createVNode("div", _hoisted_45, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.item.error.erorListSendForm,
                hasError: _ctx.state.item.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_46, [
                _createVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _withDirectives(_createVNode("select", {
                    disabled: !_ctx.state.projectList || !_ctx.state.projectList.length,
                    class: "custom-select form-control",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.state.item.sendOption.project = $event)),
                    onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.getChannelByProjectForSendOption && _ctx.getChannelByProjectForSendOption(...args)))
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.projectList, (item, itemIndex) => {
                      return (_openBlock(), _createBlock("option", {
                        value: item,
                        key: itemIndex
                      }, _toDisplayString(item.name), 9, ["value"]))
                    }), 128))
                  ], 40, ["disabled"]), [
                    [_vModelSelect, _ctx.state.item.sendOption.project]
                  ])
                ]),
                _createVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _withDirectives(_createVNode("select", {
                    disabled: 
                      !_ctx.state.channelListForSendOption ||
                        !_ctx.state.channelListForSendOption.length
                    ,
                    class: "custom-select form-control",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.state.item.sendOption.channel = $event)),
                    onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.getUserListByProjectAndChannel && _ctx.getUserListByProjectAndChannel(...args)))
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.channelListForSendOption, (item, itemIndex) => {
                      return (_openBlock(), _createBlock("option", {
                        value: item,
                        key: itemIndex
                      }, _toDisplayString(item.name), 9, ["value"]))
                    }), 128))
                  ], 40, ["disabled"]), [
                    [_vModelSelect, _ctx.state.item.sendOption.channel]
                  ])
                ]),
                _createVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _withDirectives(_createVNode("select", {
                    disabled: 
                      !_ctx.state.userListForSendOption ||
                        !_ctx.state.userListForSendOption.length
                    ,
                    class: "form-control mb-2",
                    id: "",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.state.existingMember = $event)),
                    onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.changeExistingMemberInSendOption && _ctx.changeExistingMemberInSendOption(...args)))
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.userListForSendOption, (item, itemIndex) => {
                      return (_openBlock(), _createBlock("option", {
                        value: item,
                        key: itemIndex
                      }, _toDisplayString(item.full_name) + " (" + _toDisplayString(item.email) + ") ", 9, ["value"]))
                    }), 128))
                  ], 40, ["disabled"]), [
                    [_vModelSelect, _ctx.state.existingMember]
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.users, (user, userIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "email-tag",
                      key: userIndex
                    }, [
                      _createVNode("p", _hoisted_53, [
                        _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                        }, [
                          _hoisted_54
                        ], 8, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ]),
                _createVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _withDirectives(_createVNode("textarea", {
                    class: "form-control",
                    id: "w3review",
                    name: "w3review",
                    rows: "4",
                    cols: "50",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.state.data.additionalMessage = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.data.additionalMessage]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_57, [
              _createVNode("div", _hoisted_58, [
                _createVNode("div", _hoisted_59, [
                  _createVNode("div", _hoisted_60, [
                    _hoisted_61,
                    (
                        _ctx.state.data.privacyList && _ctx.state.data.privacyList.length
                      )
                      ? (_openBlock(), _createBlock("div", _hoisted_62, [
                          _withDirectives(_createVNode("select", {
                            class: "custom-select form-control",
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.state.data.privacy = $event))
                          }, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.privacyList, (item, itemIndex) => {
                              return (_openBlock(), _createBlock("option", {
                                value: item,
                                key: itemIndex
                              }, _toDisplayString(item.name), 9, ["value"]))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.state.data.privacy]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_63, [
                      _hoisted_64,
                      _createVNode("div", _hoisted_65, [
                        _createVNode("h5", null, _toDisplayString(_ctx.state.data.privacy.value), 1),
                        _createVNode("p", _hoisted_66, _toDisplayString(_ctx.formPrivacyMessage), 1)
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_67, [
                  _createVNode("div", _hoisted_68, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.sendDigitizedForm && _ctx.sendDigitizedForm(...args)))
                    }, _toDisplayString(_ctx.state.ui.isPostLoading.sendDigitizedForm ? 'Sending...':'Send'), 1),
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      "data-dismiss": "modal",
                      onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.hideSendOptionModal && _ctx.hideSendOptionModal(...args)))
                    }, " Cancel ")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_69, [
      _createVNode("div", _hoisted_70, [
        _createVNode("div", _hoisted_71, [
          _createVNode("div", _hoisted_72, [
            _createVNode("div", _hoisted_73, [
              _createVNode("div", _hoisted_74, [
                _createVNode("h5", _hoisted_75, _toDisplayString(_ctx.state.newFormData.title), 1),
                _createVNode("p", _hoisted_76, _toDisplayString(_ctx.state.newFormData.description), 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                "aria-label": "Close",
                onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.hideTemplateModal && _ctx.hideTemplateModal(...args)))
              }, [
                _hoisted_77
              ])
            ]),
            _createVNode("div", _hoisted_78, [
              _createVNode("div", _hoisted_79, [
                _createVNode("form", null, [
                  _createVNode("fieldset", _hoisted_80, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.newFormData
                          .elements, (element, elementIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "form-group",
                        key: elementIndex
                      }, [
                        (element.type === 'title')
                          ? (_openBlock(), _createBlock(_component_TitleComponent, {
                              key: 0,
                              title: element.title,
                              description: element.description,
                              editStatus: false
                            }, null, 8, ["title", "description"]))
                          : _createCommentVNode("", true),
                        (element.type === 'textbox')
                          ? (_openBlock(), _createBlock(_component_TextBoxComponent, {
                              key: 1,
                              data: element,
                              editStatus: false
                            }, null, 8, ["data"]))
                          : _createCommentVNode("", true),
                        (element.type === 'radioButton')
                          ? (_openBlock(), _createBlock(_component_RadioButtonComponent, {
                              key: 2,
                              data: element,
                              editStatus: false
                            }, null, 8, ["data"]))
                          : _createCommentVNode("", true),
                        (element.type === 'single_select')
                          ? (_openBlock(), _createBlock(_component_SelectOption, {
                              key: 3,
                              data: element,
                              editStatus: false
                            }, null, 8, ["data"]))
                          : _createCommentVNode("", true),
                        (element.type === 'checkBox')
                          ? (_openBlock(), _createBlock(_component_CheckBox, {
                              key: 4,
                              data: element,
                              editStatus: false
                            }, null, 8, ["data"]))
                          : _createCommentVNode("", true),
                        (element.type === 'textArea')
                          ? (_openBlock(), _createBlock(_component_TextArea, {
                              key: 5,
                              data: element,
                              editStatus: false
                            }, null, 8, ["data"]))
                          : _createCommentVNode("", true),
                        (element.type === 'datePicker')
                          ? (_openBlock(), _createBlock("div", _hoisted_81, [
                              (element.title)
                                ? (_openBlock(), _createBlock("label", _hoisted_82, _toDisplayString(element.title), 1))
                                : _createCommentVNode("", true),
                              _createVNode("input", {
                                type: "text",
                                class: "form-control",
                                value: element.date
                              }, null, 8, ["value"])
                            ]))
                          : _createCommentVNode("", true),
                        (element.type === 'digitalSignature')
                          ? (_openBlock(), _createBlock("div", _hoisted_83, [
                              _createVNode("div", _hoisted_84, [
                                _createVNode("div", _hoisted_85, [
                                  _hoisted_86,
                                  (element.title)
                                    ? (_openBlock(), _createBlock("label", _hoisted_87, _toDisplayString(element.title), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_88, [
              (_ctx.state.newFormData)
                ? (_openBlock(), _createBlock("div", _hoisted_89, [
                    _createVNode("p", _hoisted_90, [
                      _hoisted_91,
                      _hoisted_92,
                      (
                        _ctx.state.newFormData.owner &&
                          _ctx.state.newFormData.owner.created_by
                      )
                        ? (_openBlock(), _createBlock("span", _hoisted_93, _toDisplayString(_ctx.state.newFormData.owner.created_by.email), 1))
                        : _createCommentVNode("", true),
                      _hoisted_94,
                      _createVNode("span", null, _toDisplayString(_ctx.state.newFormData.created_date), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.hideTemplateModal && _ctx.hideTemplateModal(...args)))
              }, " Close ")
            ])
          ])
        ])
      ])
    ])
  ]))
}